import React from 'react'

const HeritageFeatures = () =>
  <div className="page feature">
    <h1>Heritage</h1>
  </div>

export default HeritageFeatures
